// extracted by mini-css-extract-plugin
export var brand = "_bd-9";
export var compact = "_bd-6";
export var extraSmall = "_bd-7";
export var icon = "_bd-0";
export var large = "_bd-4";
export var light = "_bd-1";
export var medium = "_bd-5";
export var outline = "_bd-b";
export var primaryDark = "_bd-a";
export var primaryLight = "_bd-8";
export var primaryModern = "_bd-c";
export var success = "_bd-2";
export var successSolid = "_bd-3";